import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import platform from 'platform';
import Carousel from 're-carousel';

import { openImageModal } from "../App";
import { changeToggleColor, openReservationLink } from "./Header";
import { _commonSetCommonInfo, _commonTimestampToDate } from "../helpers/common";
import IndicatorDots from '../components/CarouselIndicatorDots';
import Buttons from '../components/CarouselButtons';
import EtcInfo from '../components/EtcInfo';

import { RiCaravanLine } from "react-icons/ri";
import { HiOutlineHome } from "react-icons/hi";
import { TbListCheck, TbPencil } from "react-icons/tb";
import { GrMapLocation } from "react-icons/gr";
import { BiBed } from "react-icons/bi";
import { IoCalendarOutline } from "react-icons/io5";

// import "../css/common.css";
import "../css/main.css";
import "../css/fluid-gallery.css";
import 'bootstrap/dist/css/bootstrap.css';

const Main = (props) => {

    let noticeListTemp = [];
    const navigate = useNavigate();
    const videoRef = useRef();

    useEffect(()=>{
        window.addEventListener('resize', handleResize);
        handleResize();

        // alert(platform.name.toLowerCase());
        // platform.name //
        // PC : Chrome, Electron, Firefox, Firefox for iOS, IE, Microsoft Edge, PhantomJS, Safari, SeaMonkey, Silk, Opera Mini, Opera
        // Mobile : Chrome Mobile, Firefox Mobile, IE Mobile, Opera Mobile
        if(platform.name.toLowerCase() === "safari") {
            videoRef.current.pause();
        }else {
            videoRef.current.play();
        }

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    },[])

    const handleResize = (e) => {

        var innerWidth = window.innerWidth;
        if(innerWidth > 1000) {

            document.getElementById("reservation_penion").innerHTML = "펜션 예약하기";
            document.getElementById("reservation_caravan").innerHTML = "카라반 예약하기";

            document.getElementById("etc_info_intro").setAttribute("rowSpan", 2);
            document.getElementById("etc_info_intro").removeAttribute("colSpan", 2);

            if(document.getElementById("temp_tr") != null) {
                document.getElementById("etc_info_intro").insertAdjacentElement("afterend", document.getElementById("etc_info_notice"));
                document.getElementById("temp_tr").remove();
            }

        }else {

            document.getElementById("reservation_penion").innerHTML = "펜션<br>예약하기";
            document.getElementById("reservation_caravan").innerHTML = "카라반<br>예약하기";

            document.getElementById("etc_info_intro").setAttribute("colSpan", 2);
            document.getElementById("etc_info_intro").removeAttribute("rowSpan", 2);

            if(document.getElementById("temp_tr") === undefined) {
                var tr = document.createElement("tr");
                tr.setAttribute("id", "temp_tr");
                tr.appendChild(document.getElementById("etc_info_notice"));
                document.getElementById("etc_info_intro").parentNode.insertAdjacentElement("afterend", tr);
            }

            if(innerWidth < 520) {
                if(document.getElementById("temp_account_tr") === undefined) {
                    var account_tr = document.createElement("tr");
                    account_tr.setAttribute("id", "temp_account_tr");
                    account_tr.appendChild(document.getElementById("etc_info_account"));
                    document.getElementById("etc_info_call").parentNode.insertAdjacentElement("afterend", account_tr);
                }
            }else {
              if(document.getElementById("temp_account_tr") != null) {
                  document.getElementById("etc_info_call").insertAdjacentElement("afterend", document.getElementById("etc_info_account"));
                  document.getElementById("temp_account_tr").remove();
              }
            }
        }
    }

    const handleLinkMove = (e, link) => {
        window.scrollTo(0, 0);
        changeToggleColor(link.split("/")[2]);
        navigate(link);
    }

    return (
        <>
            <div id="main_wrap">
                <div className="main_carousel_wrap">
                    <Carousel loop auto widgets={[IndicatorDots, Buttons]}>
                        <img className="main_carousel_img" src="https://postfiles.pstatic.net/MjAyMjA3MzBfNTAg/MDAxNjU5MTUwMjY0NjQ4.8fkMBFejL1KTWxgLfmQr-zgt9HQbCxDusHNFqwQC7cYg.KcortPxGE907ATKr70xS_hIe_59nOgKpOkcqpRJGhH0g.JPEG.bse14/1.jpg?type=w966" />
                        <img className="main_carousel_img" src="https://postfiles.pstatic.net/MjAyMjA3MzBfMjYg/MDAxNjU5MTUwMjY0ODA0.aqym0kEkvcLRUghXrGq35pRv6pHEnCOZzypn4yO_rMEg.XulbxWthXBTAvxhWhHM8i5fprsZIyEndPB2hOUlvseMg.JPEG.bse14/1_3.jpg?type=w966" />
                        <img className="main_carousel_img" src="https://postfiles.pstatic.net/MjAyMjA3MzBfMTYx/MDAxNjU5MTUwMjY0NzI0.QcFI2GKDBx5a4hqCpwVUcwBtP286DZN9Cr7qsj2RCOgg.GC_KJ-Pt-jDznMKZ-AzES-bDB3R0eNr98HNeEQ6CzJwg.JPEG.bse14/2.jpg?type=w966" />
                        <img className="main_carousel_img" src="https://postfiles.pstatic.net/MjAyMjA3MzBfMTQg/MDAxNjU5MTUwMjY0Njcx.x3FNset3DlbhtkAw2KbOCZ7iYbrPltK7GlquefC2D1kg.6-61JnMm8i82sqSMGb-R7BFhKZeDcfgoqoGXc4RUqZ8g.JPEG.bse14/4.jpg?type=w966" />
                    </Carousel>
                    <div className="main_title">
                        자연누리 펜션 · 카라반
                    </div>
                </div>

                <div className="open_reservation">
                    <div className="open_reservation_pension" onClick={(e) => {
                        window.open("https://booking.pension.onda.me/138359/calendar","","width=900px, location=no, titlebar=no, scrollbars=yes, menubar=no, status = no, left = 500, toolbar=no");
                    }}>
                        <div id="reservation_penion"></div>
                    </div>

                    <div className="open_reservation_caravan" onClick={(e) => {
                        window.open("https://booking.pension.onda.me/138360/calendar","","width=900px, location=no, titlebar=no, scrollbars=yes, menubar=no, status = no, left = 500, toolbar=no");
                    }}>
                        <div id="reservation_caravan"></div>
                    </div>
                </div>

                <div className="menu_box_wrap">
                    <div>
                        <div className="menu_box" onClick={(e)=>handleLinkMove(e, "/introduce/ABOUT")}>
                            <HiOutlineHome /><br/>
                            <span className="menu_box_eng">INTRODUCE</span><br/>
                            <span className="menu_box_kor">자연누리 소개</span>
                        </div>
                    </div>
                    <div>
                        <div className="menu_box" onClick={(e)=>handleLinkMove(e, "/terms_of_use/RESERVATION")}><TbListCheck /><br/><span className="menu_box_eng">RULES</span><br/><span className="menu_box_kor">이용수칙</span></div>
                    </div>
                    <div>
                        <div className="menu_box" onClick={(e)=>handleLinkMove(e, "/room1/ROOM")}>
                            <BiBed /><br/>
                            <span className="menu_box_eng">ROOM</span><br/>
                            <span className="menu_box_kor">객실 안내</span>
                        </div>
                    </div>
                    <div>
                        <div className="menu_box" onClick={(e)=>handleLinkMove(e, "/caravan1/ROOM")}>
                            <RiCaravanLine /><br/>
                            <span className="menu_box_eng">CARAVAN</span><br/>
                            <span className="menu_box_kor">카라반 안내</span>
                        </div>
                    </div>
                    <div>
                        <div className="menu_box" onClick={(e)=>handleLinkMove(e, "/reviews/COMMUNITY")}>
                            <TbPencil /><br/>
                            <span className="menu_box_eng">REVIEWS</span><br/>
                            <span className="menu_box_kor">이용후기</span></div>
                    </div>
                    <div>
                        <div className="menu_box" onClick={(e)=>handleLinkMove(e, "/way_to_come/ABOUT")}>
                            <GrMapLocation /><br/>
                            <span className="menu_box_eng">LOCATION</span><br/>
                            <span className="menu_box_kor">오시는 길</span></div>
                    </div>
                </div>
                <div className="main_img">
                    <div className="tz-gallery">
                        <div className="row">
                            <div className="col-sm-12 col-lg-6" style={{paddingTop:"0px !important"}}>
                                <img src="https://postfiles.pstatic.net/MjAyMjA3MzBfNTgg/MDAxNjU5MTUwMjgxODYw.oqBjTCiD4mufi1xDAID6lH4JSPBCxQxWoP8UpVnoKHwg.-1c5P8hljWxGhvOZE3BE4eysVlKJsbQz0o7LN9JK2MQg.JPEG.bse14/1.jpg?type=w966" onClick={openImageModal} />
                            </div>
                            <div className="col-sm-12 col-lg-6" style={{paddingTop:"0px !important"}}>
                                <img src="https://postfiles.pstatic.net/MjAyMjA3MzBfNjEg/MDAxNjU5MTUwMjgyNDEy.-d0QEmkjDx2p3H8BaDzf6zI6HMrQkrNIsULS1V0418sg.xNAIa9GBEG57HhGuo6eH_jgLELGWVMJglYb4ij4xAfwg.JPEG.bse14/2.jpg?type=w966" onClick={openImageModal} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-lg-6" style={{paddingTop:"0px !important"}}>
                                <img src="https://postfiles.pstatic.net/MjAyMjA3MzBfMTcg/MDAxNjU5MTUwMjgyMDY0.FJUjXbVlr_HHeyUJKggsSvobO5ee9DcbYiwH17JD0Jcg.BHFI8ozi1ND36lBH2QyNe0yBIdAVFcFTeDsy27Q68tYg.JPEG.bse14/1_3.jpg?type=w966" onClick={openImageModal} />
                            </div>
                            <div className="col-sm-12 col-lg-6" style={{paddingTop:"0px !important"}}>
                                <img src="https://postfiles.pstatic.net/MjAyMjA3MzBfMjYw/MDAxNjU5MTUwMjgyMTY5.PK4oKFQIRCLt05WyeMMcIUgS6gpUOR1jHBKQRHn6GC4g.MyZ4_CHLPTB_gkJP-kwcN-NJiPaGxO2Ri7L01j6m62wg.JPEG.bse14/1_2.jpg?type=w966" onClick={openImageModal} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-lg-4">
                                <img src="https://postfiles.pstatic.net/MjAyMjA3MzBfNTMg/MDAxNjU5MTUwMjgyNjM5.Qyx-Ib1TSPUXcn6URMIq0wVG9FA0IEYM37Kk4xz5p8Ug.wAK_PrWVDVRNMAD1SUXsUMPduXwP4DYOS1x_JYaHlNAg.JPEG.bse14/4.jpg?type=w966" onClick={openImageModal} />
                            </div>
                            <div className="col-sm-12 col-lg-4">
                                <img src="https://postfiles.pstatic.net/MjAyMjA3MzBfMjAy/MDAxNjU5MTUwMjgxOTg4.kdCYHwcmSNfUa6gPl9YrS_etbOZAfniHHcqzD1LnKecg.v_IvNpvtRDj_D4QYg6JhhQG3BmD7jir-K9qGwiJOEyYg.JPEG.bse14/3.jpg?type=w966" onClick={openImageModal}/>
                            </div>
                            <div className="col-sm-12 col-lg-4">
                                <img src="https://postfiles.pstatic.net/MjAyMjA3MzBfMjE0/MDAxNjU5MTUwMjgyNjAw.fRuElWOJa6P_pD0TXzHpxYKBuCWW1sQ1i27izWEtLAMg.pmKjIboHzElvDhkfQDp4uBe1mMu5Fvwrlyxw2oknNXAg.JPEG.bse14/5.jpg?type=w966" onClick={openImageModal}/>
                            </div>
                        </div>

                        <div className='row'>
                            <div className="col-xs-12">
                                <video id="summer_video" ref={videoRef} autoPlay controls muted loop>
                                    <source src="/main/main_list/summer_video1.mp4" type="video/mp4" />
                                </video>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-lg-4">
                                <img src="https://postfiles.pstatic.net/MjAyMjA3MzBfMjUg/MDAxNjU5MTUwMjgzMDUz.6DfTMc10X-ZX8iLa7sazMrhqs4V2bOezprtFPFhK6oUg.JGN86NZGYr-XpTeGmh59zDQ_L00qcHQEnTYIMVOOGuAg.JPEG.bse14/6.jpg?type=w966" onClick={openImageModal} />
                            </div>
                            <div className="col-sm-12 col-lg-4">
                                <img src="https://postfiles.pstatic.net/MjAyMjA3MzBfMjgy/MDAxNjU5MTUwMjgyODkw.QpJ8zL9hjWIVySFHIVfHnSxvn4Hd2jr4kYvAY7tNBLAg.oaB2U3hNgDp1jfaBL2CzpGbuwmIMNhgVzkGZjbeILqUg.JPEG.bse14/7.jpg?type=w966" onClick={openImageModal} />
                            </div>
                            <div className="col-sm-12 col-lg-4">
                                <img src="https://postfiles.pstatic.net/MjAyMjA3MzBfMjI4/MDAxNjU5MTUwMjgzMjE3.-Ocb1zj3Ob6Vz2Lp_aEvEhVqYRbfZNa5Ttyj8NpNHlcg.WOeIYvN58x4Cg8Q7zZ-hxce5CjJyFFii4B_1sBpNTsgg.JPEG.bse14/8.jpg?type=w966" onClick={openImageModal} />
                            </div>
                        </div>
                    </div>
                </div>

                <EtcInfo/>

            </div>
        </>
    )
};

export default Main;
